module.exports = __webpack_public_path__ + "cfea1b50591197e7b1abcc0f3ffcfcff.jpg";